



















import { Vue, Component } from "vue-property-decorator";
import { Tabs, TabPane } from "@brankas/web-ui";

import ClientList from "@/pagesCom/Home/ClientList/index.vue";
import FiServices from "@/pagesCom/Home/FiServices/index.vue";
import { namespace } from "vuex-class";

const configModule = namespace("config");

@Component({
  components: {
    Tabs,
    TabPane,
    ClientList,
    FiServices,
  },
})
export default class HomePage extends Vue {
  @configModule.State("currentHomeTab") currentHomeTab!: string;
  @configModule.Mutation("setCurrentHomeTab") setCurrentHomeTab!: (
    tabName: string
  ) => void;
  @configModule.Getter("isJKTDashboard") isJKTDashboard!: boolean;

  get selectedTab(): string {
    return this.currentHomeTab ?? "client-list";
  }
}
